#import "../fragments/preference-center-audience-fragment.graphql"

mutation MakeAudiencePrivate($audienceId: ID!) {
    audienceUpdate(input: {audienceId: $audienceId, isPublic: false}) {
        audience {
            ...PreferenceCenterAudience
        }
    }
}
